import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button/Button";

const PREVIEW_CHAR_LIMIT = 360;

export function agentEvidenceNeedsExpand(text: string): boolean {
  return text.trim().length > PREVIEW_CHAR_LIMIT;
}

export function AgentAssessmentSection({ evidence }: { evidence: string }) {
  const [expanded, setExpanded] = useState(false);
  const trimmed = evidence.trim();
  const canExpand = agentEvidenceNeedsExpand(trimmed);
  const showFull = expanded || !canExpand;
  const preview = canExpand && !expanded ? `${trimmed.slice(0, PREVIEW_CHAR_LIMIT).trimEnd()}…` : trimmed;

  useEffect(() => {
    setExpanded(false);
  }, [evidence]);

  if (!trimmed) {
    return <p className="text-sm text-slate-500">No evidence recorded.</p>;
  }

  return (
    <div>
      <p className="whitespace-pre-wrap text-sm leading-relaxed text-slate-700 dark:text-slate-200">{showFull ? trimmed : preview}</p>
      {canExpand ? (
        <Button
          plain
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="px-0 mt-2 text-xs font-medium text-indigo-700 hover:text-indigo-900 dark:text-indigo-200 dark:hover:text-indigo-100"
        >
          {expanded ? "Show less" : "Show full assessment"}
        </Button>
      ) : null}
    </div>
  );
}
